import { React } from "react";
import { useDispatch } from 'react-redux';
import { Notification } from "@progress/kendo-react-notification";
import { deleteNotifications } from '../../../store/actions/notificationActions';

const Success = (props) => {
  const dispatch = useDispatch();

  return (
    <Notification
      type={{
        style: "success",
        icon: true,
      }}
      closable={true}
      onClose={() => dispatch(deleteNotifications(props.index))}
    >
      <span>{props.message}</span>
    </Notification>
  )
}

export default Success;